import { render, staticRenderFns } from "./DesignEditTabSocial.vue?vue&type=template&id=08a7b054&"
import script from "./DesignEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./DesignEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports